import React from 'react';
import { mergeClassNames } from '../../utils/mergeClassNames';
import styles from './Profile.module.scss';

interface ProfileProps{
	data:{
		name:string,
		name_en:string,
		image:string,
		role:string,
		description:string,
	}
}

export class Profile extends React.Component<ProfileProps>
{
	render()
	{
		return (
			<div className={mergeClassNames([this.props['className'], 'profile'], styles)}>
				<div className={styles['image-wrapper']}>
					<div className={styles['image']} style={{backgroundImage: `url(${this.props.data['image']}`}}></div>
					{
						this.props.data['image_credits']?(
							<div className={styles['credits']}>{this.props.data['image_credits']}</div>
						):null
					}
					<div></div>
				</div>
				<div className={styles['info']}>
					<div className={styles['name-en']}>{this.props.data['name_en']}</div>
					<div className={styles['name']}>{this.props.data['name']}</div>
					<div className={styles['role']}>{this.props.data['role']}</div>
					<div className={styles['description']}>{this.props.data['description']}</div>
				</div>
			</div>
		)
	}
}